import { Typography } from "@material-ui/core";
import { FC } from "react";

const SectionTitle: FC<{ title: string }> = ({ title }) => {
  return (
    <Typography
      style={{
        marginBottom: 16,
        fontSize: 22,
      }}
    >
      {title}
    </Typography>
  );
};

export default SectionTitle;
